import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CanceledOrderFilterEntity } from '../../domain/entities/CanceledOrderFilterEntity'

export class CanceledOrderFilterModel extends CanceledOrderFilterEntity {
  fromDate?: string
  toDate?: string
  orderBranchId?: number
  orderServiceId?: number

  constructor(dataDto: CanceledOrderFilterEntity) {
    super()
    mapEntityProperties<CanceledOrderFilterModel>(this, dataDto, {
      exclude: ['orderBranch', 'orderService', 'beginDate', 'endDate'],
      map: {
        orderBranchId: dataDto.orderBranch?.id,
        orderServiceId: dataDto.orderService?.id,
        fromDate: dataDto.beginDate,
        toDate: dataDto.endDate
      }
    })
  }
}
